export const blogPosts = [
    {
      image: "https://www.shutterstock.com/image-photo/bloggingblog-concepts-ideas-white-worktable-600nw-1029506242.jpg",
      title: "How to Start with React",
      summary: "React is a JavaScript library for building user interfaces...",
      author: "Jane Doe",
      date: "March 20, 2024"
    },
    {
      image: "https://www.shutterstock.com/image-photo/bloggingblog-concepts-ideas-white-worktable-600nw-1029506242.jpg",
      title: "Advanced React Techniques",
      summary: "Dive deeper into React with hooks, context, and more...",
      author: "John Doe",
      date: "April 5, 2024"
    },
    {
        image: "https://www.shutterstock.com/image-photo/bloggingblog-concepts-ideas-white-worktable-600nw-1029506242.jpg",
        title: "Advanced React Techniques",
        summary: "Dive deeper into React with hooks, context, and more...",
        author: "John Doe",
        date: "April 5, 2024"
      },
      {
        image: "https://www.shutterstock.com/image-photo/bloggingblog-concepts-ideas-white-worktable-600nw-1029506242.jpg",
        title: "Advanced React Techniques",
        summary: "Dive deeper into React with hooks, context, and more...",
        author: "John Doe",
        date: "April 5, 2024"
      },
      {
        image: "https://www.shutterstock.com/image-photo/bloggingblog-concepts-ideas-white-worktable-600nw-1029506242.jpg",
        title: "Advanced React Techniques",
        summary: "Dive deeper into React with hooks, context, and more...",
        author: "John Doe",
        date: "April 5, 2024"
      },
      {
        image: "https://www.shutterstock.com/image-photo/bloggingblog-concepts-ideas-white-worktable-600nw-1029506242.jpg",
        title: "Advanced React Techniques",
        summary: "Dive deeper into React with hooks, context, and more...",
        author: "John Doe",
        date: "April 5, 2024"
      },
    // Add more blog posts as needed
  ];